import request from '@/api/config/request'

const prex = "/api/admin/gestao/fiscalizacao";

export function list_simples_nacional_divergencias(esr_cnpj) {
    return request({
        url: `${prex}/detalhe_divergencia/${esr_cnpj}`,
        method: 'get'
    })
}

/*
 * Marca ou desmarca divergências como desconsideradas (analisadas) pelo fiscal.
 * Uma divergência: {esr_cnpj, esr_competencia, srt_codigo, esr_analisado} -> dados = registro gravado.
 * Em lote:         {esr_analisado, divergencias: [{esr_cnpj, esr_competencia, srt_codigo}, ...]}
 *                  -> dados = lista dos registros gravados.
 * Em ambos os casos o retorno traz o fiscal e a data/hora da análise.
 */
export function desconsiderar_simples_nacional_divergencia(data) {
    return request({
        url: `${prex}/detalhe_divergencia`,
        method: 'post',
        data
    })
}
